import { FileClock } from "lucide-react";
import { Button } from "./ui/button";
import { relativeTime } from "../lib/notifications";

// « Un brouillon de cette saisie est gardé sur cet appareil » — never worded as if the server had it.
export default function DraftBanner({ pending, onRestore, onDismiss }) {
  if (!pending) return null;
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900" role="status" data-testid="draft-banner">
      <FileClock size={16} className="shrink-0" aria-hidden />
      <span className="min-w-0 flex-1">
        Brouillon retrouvé sur cet appareil ({relativeTime(new Date(pending.savedAt).toISOString())}). Il n'a pas été envoyé.
      </span>
      <span className="flex gap-2">
        <Button type="button" size="sm" onClick={onRestore} data-testid="draft-restore">Reprendre</Button>
        <Button type="button" size="sm" variant="outline" onClick={onDismiss} data-testid="draft-dismiss">Ignorer</Button>
      </span>
    </div>
  );
}
